export default __webpack_public_path__ + "static/media/Shadow's Bracers of the Fifth Stage.fd115196.jpg";